const S = {
  wrapper: { marginTop:'10px', padding:'40px', border:'3px solid grey', fontFamily:"'Georgia', serif", color:'#1a1a2e', lineHeight:'1.7' },
  h1: { fontSize:'2rem', fontWeight:'700', borderBottom:'3px solid #2E75B6', paddingBottom:'8px', marginBottom:'24px', color:'#1F3864' },
  h2: { fontSize:'1.3rem', fontWeight:'700', color:'#2E75B6', marginTop:'36px', marginBottom:'12px', borderLeft:'4px solid #2E75B6', paddingLeft:'10px' },
  p: { marginBottom:'12px', fontSize:'0.97rem' },
  infoBox: { background:'#EBF3FB', border:'2px solid #2E75B6', borderRadius:'6px', padding:'16px 20px', margin:'16px 0' },
  infoBoxTitle: { fontWeight:'700', fontFamily:"'Courier New', monospace", fontSize:'0.88rem', color:'#1F3864', marginBottom:'8px' },
  infoBoxItem: { fontSize:'0.9rem', margin:'4px 0', paddingLeft:'12px', borderLeft:'2px solid #2E75B6' },
  table: { width:'100%', borderCollapse:'collapse', marginBottom:'20px', fontSize:'0.92rem' },
  th: { background:'#2E75B6', color:'#fff', padding:'10px 14px', textAlign:'left', fontWeight:'700', fontSize:'0.9rem' },
  tdE: { padding:'10px 14px', borderBottom:'1px solid #ccd9ea', verticalAlign:'top', background:'#f5f9ff' },
  tdO: { padding:'10px 14px', borderBottom:'1px solid #ccd9ea', verticalAlign:'top', background:'#fff' },
  tdL: { fontWeight:'600', color:'#1F3864', whiteSpace:'nowrap', width:'220px' },
  code: { fontFamily:"'Courier New', monospace", fontSize:'0.88rem', whiteSpace:'pre-wrap' },
  dWrap: { margin:'24px 0', background:'#f8fbff', border:'1px solid #ccd9ea', borderRadius:'8px', padding:'20px' },
  dTitle: { fontWeight:'700', fontSize:'0.95rem', color:'#1F3864', marginBottom:'12px', textAlign:'center', letterSpacing:'0.02em' },
  dCaption: { fontSize:'0.84rem', color:'#555', textAlign:'center', marginTop:'10px', fontStyle:'italic' },
};

function InfoBox({ title, items }) {
  return (
    <div style={S.infoBox}>
      <div style={S.infoBoxTitle}>{title}</div>
      {items.map((item, i) => <div key={i} style={S.infoBoxItem}>{item}</div>)}
    </div>
  );
}

function Table2({ rows }) {
  return (
    <table style={S.table}>
      <thead><tr>
        <th style={{ ...S.th, width:'220px' }}>Concept</th>
        <th style={S.th}>Formula / Notes</th>
      </tr></thead>
      <tbody>
        {rows.map(([label, content], i) => (
          <tr key={i}>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.tdL }}>{label}</td>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.code }}>{content}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

// ── Diagram 1: Centroid Concept ──────────────────────────────────
function DiagramCentroidConcept() {
  const W = 900, H = 340;

  // Panel 1: Discrete point masses
  const p1w = 280;
  const pts = [
    { x: 80,  y: 100, m: 3, label:'m₁=3' },
    { x: 200, y: 80,  m: 5, label:'m₂=5' },
    { x: 250, y: 200, m: 2, label:'m₃=2' },
    { x: 100, y: 220, m: 4, label:'m₄=4' },
  ];
  const totalM = pts.reduce((s,p)=>s+p.m, 0);
  const cx1 = pts.reduce((s,p)=>s+p.m*p.x,0)/totalM;
  const cy1 = pts.reduce((s,p)=>s+p.m*p.y,0)/totalM;

  // Panel 2: Triangle centroid (median intersection)
  const p2x = 300;
  const tAx=330,tAy=280, tBx=560,tBy=280, tCx=450,tCy=90;
  const tGx=(tAx+tBx+tCx)/3, tGy=(tAy+tBy+tCy)/3;
  const tMABx=(tAx+tBx)/2, tMABy=(tAy+tBy)/2;
  const tMBCx=(tBx+tCx)/2, tMBCy=(tBy+tCy)/2;
  const tMACx=(tAx+tCx)/2, tMACy=(tAy+tCy)/2;

  // Panel 3: Concept — balance point
  const p3x = 600;
  const bTAx=640,bTAy=280, bTBx=870,bTBy=280, bTCx=720,bTCy=100;
  const bGx=(bTAx+bTBx+bTCx)/3, bGy=(bTAy+bTBy+bTCy)/3;
  // fulcrum symbol
  const fulX = bGx, fulY = bTAy+24;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>The Centroid — Centre of Mass for Discrete Points, Triangles, and Laminas</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>

        {/* Panel 1: discrete point masses */}
        <rect x={10} y={10} width={p1w} height={H-20} rx={5} fill="#fff" stroke="#ccd9ea"/>
        <text x={10+p1w/2} y={28} textAnchor="middle" fontSize="14" fill="#1F3864" fontWeight="700">Discrete Point Masses</text>
        <text x={10+p1w/2} y={44} textAnchor="middle" fontSize="11" fill="#888">x̄ = Σmᵢxᵢ / Σmᵢ</text>

        {/* grid lines */}
        {[80,120,160,200,240].map(v=>(
          <g key={v}>
            <line x1={v} y1={60} x2={v} y2={240} stroke="#f0f4fa" strokeWidth="1"/>
            <line x1={20} y1={v-20+60} x2={280} y2={v-20+60} stroke="#f0f4fa" strokeWidth="1"/>
          </g>
        ))}

        {/* lines from centroid to each mass */}
        {pts.map((p,i)=>(
          <line key={i} x1={cx1+14} y1={cy1} x2={p.x+14} y2={p.y} stroke="#ccd9ea" strokeWidth="1.2" strokeDasharray="4,3"/>
        ))}

        {/* point masses */}
        {pts.map((p,i)=>(
          <g key={i}>
            <circle cx={p.x+14} cy={p.y} r={p.m*4} fill="#2E75B6" fillOpacity="0.25" stroke="#2E75B6" strokeWidth="1.5"/>
            <circle cx={p.x+14} cy={p.y} r={4} fill="#2E75B6"/>
            <text x={p.x+14} y={p.y-p.m*4-5} textAnchor="middle" fontSize="11" fill="#2E75B6" fontWeight="700">{p.label}</text>
          </g>
        ))}

        {/* centroid */}
        <circle cx={cx1+14} cy={cy1} r={8} fill="#c0392b" stroke="#fff" strokeWidth="2"/>
        <text x={cx1+24} y={cy1-10} fontSize="12" fill="#c0392b" fontWeight="700">G (centroid)</text>

        <rect x={18} y={258} width={p1w-16} height={56} rx={3} fill="#EBF3FB" stroke="#2E75B6" strokeWidth="1"/>
        <text x={24} y={273} fontSize="12" fill="#1F3864" fontWeight="700">Centre of mass formulae:</text>
        <text x={24} y={289} fontSize="11" fill="#2E75B6" fontFamily="'Courier New',monospace">x̄ = Σmᵢxᵢ / Σmᵢ</text>
        <text x={24} y={304} fontSize="11" fill="#2E75B6" fontFamily="'Courier New',monospace">ȳ = Σmᵢyᵢ / Σmᵢ</text>

        {/* Panel 2: triangle centroid */}
        <rect x={p2x} y={10} width={280} height={H-20} rx={5} fill="#fff" stroke="#ccd9ea"/>
        <text x={p2x+140} y={28} textAnchor="middle" fontSize="14" fill="#1F3864" fontWeight="700">Triangle — Median Intersection</text>
        <text x={p2x+140} y={44} textAnchor="middle" fontSize="11" fill="#888">G divides each median 2:1 from vertex</text>

        <polygon points={`${tAx},${tAy} ${tBx},${tBy} ${tCx},${tCy}`} fill="#d0e8ff" fillOpacity="0.35" stroke="#2E75B6" strokeWidth="2"/>

        {/* medians */}
        <line x1={tAx} y1={tAy} x2={tMBCx} y2={tMBCy} stroke="#c0392b" strokeWidth="1.8" strokeDasharray="5,3"/>
        <line x1={tBx} y1={tBy} x2={tMACx} y2={tMACy} stroke="#27ae60" strokeWidth="1.8" strokeDasharray="5,3"/>
        <line x1={tCx} y1={tCy} x2={tMABx} y2={tMABy} stroke="#9b59b6" strokeWidth="1.8" strokeDasharray="5,3"/>

        {/* midpoint dots */}
        {[[tMBCx,tMBCy],[tMACx,tMACy],[tMABx,tMABy]].map(([mx,my],i)=>(
          <circle key={i} cx={mx} cy={my} r={4} fill={['#c0392b','#27ae60','#9b59b6'][i]} stroke="#fff" strokeWidth="1.5"/>
        ))}

        {/* 2:1 ratio annotation */}
        {(()=>{
          // On the A-to-MBC median, mark 2/3 of the way (which is G)
          const twoThirdX = tAx + 2/3*(tMBCx-tAx);
          const twoThirdY = tAy + 2/3*(tMBCy-tAy);
          return <>
            <text x={tAx-18} y={tAy+5} fontSize="13" fill="#1F3864" fontWeight="700">A</text>
            <text x={tBx+6} y={tBy+5} fontSize="13" fill="#1F3864" fontWeight="700">B</text>
            <text x={tCx-4} y={tCy-8} fontSize="13" fill="#1F3864" fontWeight="700">C</text>
            {/* 2:1 ratio marks */}
            <text x={(tAx+tGx)/2-28} y={(tAy+tGy)/2} fontSize="10" fill="#c0392b" fontWeight="700">2</text>
            <text x={(tGx+tMBCx)/2+4} y={(tGy+tMBCy)/2} fontSize="10" fill="#c0392b" fontWeight="700">1</text>
          </>;
        })()}

        <circle cx={tGx} cy={tGy} r={8} fill="#e07b00" stroke="#fff" strokeWidth="2"/>
        <text x={tGx+12} y={tGy-6} fontSize="12" fill="#e07b00" fontWeight="700">G</text>

        <rect x={p2x+8} y={258} width={264} height={56} rx={3} fill="#EBF3FB" stroke="#2E75B6" strokeWidth="1"/>
        <text x={p2x+14} y={273} fontSize="12" fill="#1F3864" fontWeight="700">Triangle centroid:</text>
        <text x={p2x+14} y={289} fontSize="11" fill="#2E75B6" fontFamily="'Courier New',monospace">G = ((x₁+x₂+x₃)/3, (y₁+y₂+y₃)/3)</text>
        <text x={p2x+14} y={305} fontSize="11" fill="#555">Each median split 2:1 (vertex:midpoint)</text>

        {/* Panel 3: balance point */}
        <rect x={p3x} y={10} width={W-p3x-10} height={H-20} rx={5} fill="#fff" stroke="#ccd9ea"/>
        <text x={p3x+(W-p3x-10)/2} y={28} textAnchor="middle" fontSize="14" fill="#1F3864" fontWeight="700">Physical Interpretation</text>
        <text x={p3x+(W-p3x-10)/2} y={44} textAnchor="middle" fontSize="11" fill="#888">Balance point of a uniform lamina</text>

        <polygon points={`${bTAx},${bTAy} ${bTBx},${bTBy} ${bTCx},${bTCy}`} fill="#d0e8ff" fillOpacity="0.45" stroke="#2E75B6" strokeWidth="2"/>
        <text x={bTAx-16} y={bTAy+5} fontSize="12" fill="#1F3864" fontWeight="700">A</text>
        <text x={bTBx+5} y={bTBy+5} fontSize="12" fill="#1F3864" fontWeight="700">B</text>
        <text x={bTCx-4} y={bTCy-8} fontSize="12" fill="#1F3864" fontWeight="700">C</text>

        {/* gravity arrow */}
        <line x1={bGx} y1={bGy} x2={bGx} y2={bTAy-2} stroke="#c0392b" strokeWidth="2"/>
        <polygon points={`${bGx},${bTAy} ${bGx-5},${bTAy-12} ${bGx+5},${bTAy-12}`} fill="#c0392b"/>

        {/* fulcrum triangle */}
        <polygon points={`${fulX},${fulY} ${fulX-16},${fulY+22} ${fulX+16},${fulY+22}`} fill="#e07b00"/>
        <line x1={fulX-22} y1={fulY+25} x2={fulX+22} y2={fulY+25} stroke="#e07b00" strokeWidth="2"/>

        <circle cx={bGx} cy={bGy} r={7} fill="#e07b00" stroke="#fff" strokeWidth="2"/>
        <text x={bGx+10} y={bGy-8} fontSize="12" fill="#e07b00" fontWeight="700">G</text>
        <text x={bGx+4} y={bTAy-8} fontSize="11" fill="#c0392b" fontWeight="700">weight</text>

        <rect x={p3x+8} y={258} width={W-p3x-26} height={56} rx={3} fill="#fff7ee" stroke="#e07b00" strokeWidth="1"/>
        <text x={p3x+14} y={273} fontSize="12" fill="#1F3864" fontWeight="700">G = balance point of the shape</text>
        <text x={p3x+14} y={289} fontSize="11" fill="#555">Uniform lamina: centroid = centre of mass</text>
        <text x={p3x+14} y={305} fontSize="11" fill="#555">Object balances on any axis through G</text>
      </svg>
      <div style={S.dCaption}>The centroid is the weighted average position of a body. For discrete masses, it is the mass-weighted mean of coordinates. For a uniform triangle it is the intersection of the three medians, and it physically represents the balance point — the point where the shape would balance on a pin.</div>
    </div>
  );
}

// ── Diagram 2: Centroids of Standard Shapes ──────────────────────
function DiagramStandardShapes() {
  const W = 900, H = 330;
  const PW = (W - 6*8) / 5;

  // Shape data: each drawn in its own panel
  const shapes = [
    { title:'Rectangle', sub:'x̄=b/2, ȳ=h/2', color:'#2E75B6', fill:'#d0e8ff' },
    { title:'Triangle', sub:'x̄=b/3, ȳ=h/3', color:'#27ae60', fill:'#d0f0d8' },
    { title:'Semicircle', sub:'ȳ = 4r/3π', color:'#c0392b', fill:'#fde8e8' },
    { title:'Quarter Circle', sub:'x̄=ȳ=4r/3π', color:'#9b59b6', fill:'#f5d0ff' },
    { title:'Right Triangle', sub:'x̄=b/3, ȳ=h/3', color:'#e07b00', fill:'#fff0cc' },
  ];

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Centroids of Standard 2D Shapes — Measured from the Origin</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        {shapes.map((sh, idx) => {
          const x0 = 8 + idx*(PW+8);
          const cx = x0 + PW/2;
          const bw = PW - 24, bh = 130;
          const bx = x0 + 12, by = 110;
          const r = bw * 0.46;

          // centroid positions for each shape
          let gx, gy, shapeEl;

          if (idx === 0) {
            // Rectangle: centroid at b/2, h/2
            gx = bx + bw/2; gy = by - bh/2;
            shapeEl = <>
              <rect x={bx} y={by-bh} width={bw} height={bh} fill={sh.fill} fillOpacity="0.5" stroke={sh.color} strokeWidth="2"/>
              {/* dimension arrows */}
              <line x1={bx} y1={by+10} x2={bx+bw} y2={by+10} stroke={sh.color} strokeWidth="1.2"/>
              <line x1={bx} y1={by+6} x2={bx} y2={by+14} stroke={sh.color} strokeWidth="1.2"/>
              <line x1={bx+bw} y1={by+6} x2={bx+bw} y2={by+14} stroke={sh.color} strokeWidth="1.2"/>
              <text x={bx+bw/2} y={by+22} textAnchor="middle" fontSize="12" fill={sh.color} fontWeight="700">b</text>
              <line x1={bx-10} y1={by} x2={bx-10} y2={by-bh} stroke={sh.color} strokeWidth="1.2"/>
              <line x1={bx-14} y1={by} x2={bx-6} y2={by} stroke={sh.color} strokeWidth="1.2"/>
              <line x1={bx-14} y1={by-bh} x2={bx-6} y2={by-bh} stroke={sh.color} strokeWidth="1.2"/>
              <text x={bx-22} y={by-bh/2+5} textAnchor="middle" fontSize="12" fill={sh.color} fontWeight="700">h</text>
              {/* dashed centroid lines */}
              <line x1={bx} y1={gy} x2={bx+bw} y2={gy} stroke={sh.color} strokeWidth="1" strokeDasharray="4,3" opacity="0.5"/>
              <line x1={gx} y1={by} x2={gx} y2={by-bh} stroke={sh.color} strokeWidth="1" strokeDasharray="4,3" opacity="0.5"/>
            </>;
          } else if (idx === 1) {
            // Isosceles triangle: centroid at 1/3 height
            const tAx=bx, tAy=by, tBx=bx+bw, tBy=by, tCx=bx+bw/2, tCy=by-bh;
            gx=(tAx+tBx+tCx)/3; gy=(tAy+tBy+tCy)/3;
            shapeEl = <>
              <polygon points={`${tAx},${tAy} ${tBx},${tBy} ${tCx},${tCy}`} fill={sh.fill} fillOpacity="0.5" stroke={sh.color} strokeWidth="2"/>
              <line x1={bx} y1={by+10} x2={bx+bw} y2={by+10} stroke={sh.color} strokeWidth="1.2"/>
              <text x={bx+bw/2} y={by+22} textAnchor="middle" fontSize="12" fill={sh.color} fontWeight="700">b</text>
              <line x1={tCx} y1={tCy} x2={tCx} y2={by} stroke={sh.color} strokeWidth="1" strokeDasharray="3,3" opacity="0.5"/>
              <text x={tCx+6} y={by-bh/2+5} fontSize="12" fill={sh.color} fontWeight="700">h</text>
              <line x1={bx} y1={gy} x2={bx+bw} y2={gy} stroke={sh.color} strokeWidth="1" strokeDasharray="4,3" opacity="0.5"/>
            </>;
          } else if (idx === 2) {
            // Semicircle: centroid at 4r/3π above base
            const scx = cx, scy = by;
            const gy_offset = 4*r/(3*Math.PI);
            gx = scx; gy = scy - gy_offset;
            const pts = [];
            for(let a=0; a<=Math.PI; a+=0.04) pts.push(`${scx+r*Math.cos(a)},${scy-r*Math.sin(a)}`);
            shapeEl = <>
              <polygon points={[`${scx-r},${scy}`, ...pts, `${scx+r},${scy}`].join(' ')} fill={sh.fill} fillOpacity="0.5" stroke={sh.color} strokeWidth="2"/>
              <line x1={scx-r} y1={scy+10} x2={scx+r} y2={scy+10} stroke={sh.color} strokeWidth="1.2"/>
              <text x={scx} y={scy+22} textAnchor="middle" fontSize="11" fill={sh.color} fontWeight="700">2r</text>
              <line x1={scx} y1={scy} x2={scx+r*0.707} y2={scy-r*0.707} stroke={sh.color} strokeWidth="1.2"/>
              <text x={scx+r*0.35} y={scy-r*0.35-4} fontSize="11" fill={sh.color} fontWeight="700">r</text>
              <line x1={scx-r+4} y1={gy} x2={scx+r-4} y2={gy} stroke={sh.color} strokeWidth="1" strokeDasharray="4,3" opacity="0.5"/>
            </>;
          } else if (idx === 3) {
            // Quarter circle: centroid at 4r/3π from each axis
            const qcx = bx, qcy = by;
            const off = 4*r/(3*Math.PI);
            gx = qcx + off; gy = qcy - off;
            const pts = [];
            for(let a=0; a<=Math.PI/2; a+=0.04) pts.push(`${qcx+r*Math.cos(a)},${qcy-r*Math.sin(a)}`);
            shapeEl = <>
              <polygon points={[`${qcx},${qcy}`, ...pts, `${qcx+r},${qcy}`].join(' ')} fill={sh.fill} fillOpacity="0.5" stroke={sh.color} strokeWidth="2"/>
              <line x1={qcx} y1={qcy+10} x2={qcx+r} y2={qcy+10} stroke={sh.color} strokeWidth="1.2"/>
              <text x={qcx+r/2} y={qcy+22} textAnchor="middle" fontSize="11" fill={sh.color} fontWeight="700">r</text>
              <line x1={qcx-10} y1={qcy} x2={qcx-10} y2={qcy-r} stroke={sh.color} strokeWidth="1.2"/>
              <text x={qcx-22} y={qcy-r/2+5} fontSize="11" fill={sh.color} fontWeight="700">r</text>
              <line x1={qcx} y1={gy} x2={gx} y2={gy} stroke={sh.color} strokeWidth="1" strokeDasharray="4,3" opacity="0.5"/>
              <line x1={gx} y1={qcy} x2={gx} y2={gy} stroke={sh.color} strokeWidth="1" strokeDasharray="4,3" opacity="0.5"/>
            </>;
          } else {
            // Right triangle: centroid at b/3 from right angle
            const rtAx=bx, rtAy=by, rtBx=bx+bw, rtBy=by, rtCx=bx, rtCy=by-bh;
            gx=(rtAx+rtBx+rtCx)/3; gy=(rtAy+rtBy+rtCy)/3;
            shapeEl = <>
              <polygon points={`${rtAx},${rtAy} ${rtBx},${rtBy} ${rtCx},${rtCy}`} fill={sh.fill} fillOpacity="0.5" stroke={sh.color} strokeWidth="2"/>
              <rect x={rtAx} y={rtAy-12} width={11} height={11} fill="none" stroke={sh.color} strokeWidth="1.5"/>
              <line x1={bx} y1={by+10} x2={bx+bw} y2={by+10} stroke={sh.color} strokeWidth="1.2"/>
              <text x={bx+bw/2} y={by+22} textAnchor="middle" fontSize="12" fill={sh.color} fontWeight="700">b</text>
              <line x1={bx-10} y1={by} x2={bx-10} y2={by-bh} stroke={sh.color} strokeWidth="1.2"/>
              <text x={bx-22} y={by-bh/2+5} fontSize="12" fill={sh.color} fontWeight="700">h</text>
              <line x1={bx} y1={gy} x2={bx+bw} y2={gy} stroke={sh.color} strokeWidth="1" strokeDasharray="4,3" opacity="0.5"/>
              <line x1={gx} y1={by} x2={gx} y2={by-bh} stroke={sh.color} strokeWidth="1" strokeDasharray="4,3" opacity="0.5"/>
            </>;
          }

          return (
            <g key={sh.title}>
              <rect x={x0} y={10} width={PW} height={H-20} rx={5} fill="#fff" stroke="#ccd9ea"/>
              <text x={cx} y={26} textAnchor="middle" fontSize="13" fill="#1F3864" fontWeight="700">{sh.title}</text>
              <text x={cx} y={40} textAnchor="middle" fontSize="10" fill="#888">{sh.sub}</text>
              {shapeEl}
              <circle cx={gx} cy={gy} r={7} fill={sh.color} stroke="#fff" strokeWidth="2"/>
              <text x={gx+10} y={gy-6} fontSize="11" fill={sh.color} fontWeight="700">G</text>
              <rect x={x0+4} y={255} width={PW-8} height={56} rx={3} fill={sh.fill} fillOpacity="0.4" stroke={sh.color} strokeWidth="1"/>
              <text x={cx} y={270} textAnchor="middle" fontSize="11" fill="#1F3864" fontWeight="700">{sh.title}</text>
              <text x={cx} y={284} textAnchor="middle" fontSize="10" fill="#555" fontFamily="'Courier New',monospace">{sh.sub.split(',')[0]}</text>
              <text x={cx} y={297} textAnchor="middle" fontSize="10" fill="#555" fontFamily="'Courier New',monospace">{sh.sub.split(',')[1] || ''}</text>
            </g>
          );
        })}
      </svg>
      <div style={S.dCaption}>Standard shape centroids are measured from a reference origin (typically a corner or the centre of the base). Dashed lines show the centroidal axes. The centroid G is always inside the shape for convex figures. For a semicircle the centroid is at 4r/(3π) ≈ 0.424r above the diameter.</div>
    </div>
  );
}

// ── Diagram 3: Composite Bodies ──────────────────────────────────
function DiagramComposite() {
  const W = 900, H = 350;

  // Example: Rectangle with a circular hole
  // Rectangle: 0 to 200 wide, 0 to 150 tall, origin bottom-left
  const sc = 1.1;
  const ox = 60, oy = 260; // SVG origin (bottom-left of shape)
  const rW = 200*sc, rH = 150*sc;
  const holeR = 30*sc;
  const holeCx = ox + 140*sc, holeCy = oy - 80*sc;

  // Centroids in real coords (from ox, oy)
  const rectCx = ox + rW/2, rectCy = oy - rH/2;
  const rectA = rW * rH;
  const holeA = Math.PI * holeR * holeR;
  const compCx = (rectCx*rectA - holeCx*holeA) / (rectA - holeA);
  const compCy = (rectCy*rectA - holeCy*holeA) / (rectA - holeA);

  // Right panel: step-by-step method
  const rpx = 520;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Composite Bodies — Subtracting Holes and Combining Parts</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>

        {/* Left panel: the composite shape */}
        <rect x={10} y={10} width={490} height={H-20} rx={5} fill="#fff" stroke="#ccd9ea"/>
        <text x={255} y={28} textAnchor="middle" fontSize="15" fill="#1F3864" fontWeight="700">Rectangle with Circular Cutout</text>

        {/* Rectangle */}
        <rect x={ox} y={oy-rH} width={rW} height={rH} fill="#d0e8ff" fillOpacity="0.45" stroke="#2E75B6" strokeWidth="2"/>

        {/* Hole (white out) */}
        <circle cx={holeCx} cy={holeCy} r={holeR} fill="#f8fbff" stroke="#c0392b" strokeWidth="2" strokeDasharray="5,3"/>
        <text x={holeCx} y={holeCy+4} textAnchor="middle" fontSize="11" fill="#c0392b" fontWeight="700">hole</text>

        {/* Dimension lines */}
        <line x1={ox} y1={oy+14} x2={ox+rW} y2={oy+14} stroke="#2E75B6" strokeWidth="1.2"/>
        <line x1={ox} y1={oy+10} x2={ox} y2={oy+18} stroke="#2E75B6" strokeWidth="1.2"/>
        <line x1={ox+rW} y1={oy+10} x2={ox+rW} y2={oy+18} stroke="#2E75B6" strokeWidth="1.2"/>
        <text x={ox+rW/2} y={oy+28} textAnchor="middle" fontSize="12" fill="#2E75B6" fontWeight="700">b</text>

        <line x1={ox-14} y1={oy} x2={ox-14} y2={oy-rH} stroke="#2E75B6" strokeWidth="1.2"/>
        <line x1={ox-18} y1={oy} x2={ox-10} y2={oy} stroke="#2E75B6" strokeWidth="1.2"/>
        <line x1={ox-18} y1={oy-rH} x2={ox-10} y2={oy-rH} stroke="#2E75B6" strokeWidth="1.2"/>
        <text x={ox-28} y={oy-rH/2+5} textAnchor="middle" fontSize="12" fill="#2E75B6" fontWeight="700">h</text>

        {/* Hole radius */}
        <line x1={holeCx} y1={holeCy} x2={holeCx+holeR} y2={holeCy} stroke="#c0392b" strokeWidth="1.4"/>
        <text x={holeCx+holeR/2} y={holeCy-5} textAnchor="middle" fontSize="11" fill="#c0392b" fontWeight="700">r</text>

        {/* Rectangle centroid */}
        <circle cx={rectCx} cy={rectCy} r={6} fill="#2E75B6" stroke="#fff" strokeWidth="1.5"/>
        <text x={rectCx+9} y={rectCy-6} fontSize="11" fill="#2E75B6" fontWeight="700">G₁</text>
        <line x1={ox} y1={rectCy} x2={ox+rW} y2={rectCy} stroke="#2E75B6" strokeWidth="0.8" strokeDasharray="3,3" opacity="0.5"/>
        <line x1={rectCx} y1={oy} x2={rectCx} y2={oy-rH} stroke="#2E75B6" strokeWidth="0.8" strokeDasharray="3,3" opacity="0.5"/>

        {/* Hole centroid */}
        <circle cx={holeCx} cy={holeCy} r={5} fill="#c0392b" stroke="#fff" strokeWidth="1.5"/>
        <text x={holeCx+8} y={holeCy-6} fontSize="11" fill="#c0392b" fontWeight="700">G₂</text>

        {/* Composite centroid */}
        <circle cx={compCx} cy={compCy} r={8} fill="#e07b00" stroke="#fff" strokeWidth="2"/>
        <text x={compCx+11} y={compCy-7} fontSize="13" fill="#e07b00" fontWeight="700">G</text>
        <line x1={ox} y1={compCy} x2={ox+rW} y2={compCy} stroke="#e07b00" strokeWidth="1" strokeDasharray="4,3"/>
        <line x1={compCx} y1={oy} x2={compCx} y2={oy-rH} stroke="#e07b00" strokeWidth="1" strokeDasharray="4,3"/>

        {/* x̄, ȳ coordinates */}
        <line x1={ox} y1={oy} x2={compCx} y2={oy} stroke="#555" strokeWidth="1.2"/>
        <text x={(ox+compCx)/2} y={oy+14} textAnchor="middle" fontSize="11" fill="#555" fontWeight="700">x̄</text>
        <line x1={ox} y1={oy} x2={ox} y2={compCy} stroke="#555" strokeWidth="1.2"/>
        <text x={ox-20} y={(oy+compCy)/2+4} textAnchor="middle" fontSize="11" fill="#555" fontWeight="700">ȳ</text>

        {/* Right panel: formula method */}
        <rect x={rpx} y={10} width={W-rpx-10} height={H-20} rx={5} fill="#fff" stroke="#ccd9ea"/>
        <text x={rpx+(W-rpx-10)/2} y={28} textAnchor="middle" fontSize="15" fill="#1F3864" fontWeight="700">Composite Method</text>

        {[
          {y:38,  bg:'#EBF3FB', bc:'#2E75B6',  n:'1', txt:'List each part with its area and centroid',
           lines:['Part 1 (rect): A₁ = bh,  G₁ = (b/2, h/2)','Part 2 (hole): A₂ = πr²,  G₂ = (xₕ, yₕ)']},
          {y:118, bg:'#f0fff4', bc:'#27ae60',   n:'2', txt:'Apply the composite formula',
           lines:['x̄ = (A₁x̄₁ − A₂x̄₂) / (A₁ − A₂)','ȳ = (A₁ȳ₁ − A₂ȳ₂) / (A₁ − A₂)']},
          {y:198, bg:'#fff7ee', bc:'#e07b00',   n:'3', txt:'Sign convention',
           lines:['Add parts with +Aᵢ,  subtract holes with −Aᵢ','Works for any number of parts and holes']},
          {y:278, bg:'#f5d0ff', bc:'#9b59b6',   n:'✓', txt:'General formula',
           lines:['x̄ = Σ(±Aᵢ x̄ᵢ) / Σ(±Aᵢ)','ȳ = Σ(±Aᵢ ȳᵢ) / Σ(±Aᵢ)']},
        ].map(({y,bg,bc,n,txt,lines})=>(
          <g key={n}>
            <rect x={rpx+8} y={y} width={W-rpx-26} height={72} rx={4} fill={bg} stroke={bc} strokeWidth="1.2"/>
            <rect x={rpx+10} y={y+2} width={24} height={24} rx={12} fill={bc}/>
            <text x={rpx+22} y={y+18} textAnchor="middle" fontSize="13" fill="#fff" fontWeight="700">{n}</text>
            <text x={rpx+42} y={y+16} fontSize="12" fill="#1F3864" fontWeight="700">{txt}</text>
            {lines.map((ln,i)=>(
              <text key={i} x={rpx+14} y={y+36+i*17} fontSize="11" fill="#444" fontFamily="'Courier New',monospace">{ln}</text>
            ))}
          </g>
        ))}
      </svg>
      <div style={S.dCaption}>For composite shapes, find the centroid of each part, then take the area-weighted average. Holes are treated as parts with negative area. The method works for any combination of standard shapes — always use a consistent reference origin for all coordinates.</div>
    </div>
  );
}

// ── Diagram 4: Centroid by Integration ───────────────────────────
function DiagramIntegration() {
  const W = 900, H = 330;

  // Left: x̄ via vertical strips for y = x²
  const lw = 430;
  const iox = 50, ioy = 260, isc = 58;
  const tx = x => iox + x*isc;
  const ty = y => ioy - y*isc;

  const curvePts = [];
  for(let x=0; x<=2.4; x+=0.06) curvePts.push(`${tx(x)},${ty(x*x)}`);

  // strips between 0 and 2
  const strips = [];
  for(let i=0; i<5; i++) {
    const x1=i*0.4, x2=(i+1)*0.4, xm=(x1+x2)/2;
    const ym = xm*xm;
    strips.push({x1:tx(x1), x2:tx(x2), y0:ioy, ym:ty(ym/2), ytop:ty(ym)});
  }

  // Right: second moment / Pappus
  const rpx = 470;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Centroid by Integration — Vertical Strips and the Area Moment Method</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>

        {/* Left: integration visual */}
        <rect x={10} y={10} width={lw} height={H-20} rx={5} fill="#fff" stroke="#ccd9ea"/>
        <text x={10+lw/2} y={28} textAnchor="middle" fontSize="15" fill="#1F3864" fontWeight="700">Centroid of Area by Integration</text>
        <text x={10+lw/2} y={44} textAnchor="middle" fontSize="11" fill="#888">y = x², from x = 0 to x = 2</text>

        {/* axes */}
        <line x1={iox-10} y1={ioy} x2={tx(2.5)} y2={ioy} stroke="#1F3864" strokeWidth="1.4"/>
        <line x1={iox} y1={ioy+10} x2={iox} y2={ty(5.5)} stroke="#1F3864" strokeWidth="1.4"/>
        <polygon points={`${tx(2.5)},${ioy} ${tx(2.5)-7},${ioy-4} ${tx(2.5)-7},${ioy+4}`} fill="#1F3864"/>
        <polygon points={`${iox},${ty(5.5)} ${iox-4},${ty(5.5)+7} ${iox+4},${ty(5.5)+7}`} fill="#1F3864"/>
        <text x={tx(2.5)+8} y={ioy+4} fontSize="13" fill="#1F3864">x</text>
        <text x={iox+4} y={ty(5.5)-4} fontSize="13" fill="#1F3864">y</text>
        {[1,2].map(v=>(
          <g key={v}>
            <text x={tx(v)} y={ioy+14} textAnchor="middle" fontSize="11" fill="#bbb">{v}</text>
            <text x={iox-8} y={ty(v*v)+4} textAnchor="end" fontSize="11" fill="#bbb">{v*v}</text>
          </g>
        ))}

        {/* vertical strips */}
        {strips.map((s,i)=>(
          <rect key={i} x={s.x1} y={s.ytop} width={s.x2-s.x1} height={ioy-s.ytop}
            fill="#2E75B6" fillOpacity={0.08+i*0.04} stroke="#2E75B6" strokeWidth="0.8"/>
        ))}

        {/* curve */}
        <polyline points={curvePts.join(' ')} fill="none" stroke="#2E75B6" strokeWidth="2.5"/>

        {/* area limits */}
        <line x1={tx(2)} y1={ioy} x2={tx(2)} y2={ty(4)} stroke="#9b59b6" strokeWidth="1.5" strokeDasharray="4,3"/>
        <text x={tx(2)} y={ioy+14} textAnchor="middle" fontSize="12" fill="#9b59b6" fontWeight="700">2</text>
        <text x={iox-8} y={ioy+4} textAnchor="end" fontSize="12" fill="#9b59b6" fontWeight="700">0</text>

        {/* centroid of one strip label */}
        {(()=>{
          const s = strips[2];
          return <>
            <circle cx={(s.x1+s.x2)/2} cy={s.ym} r={4} fill="#e07b00"/>
            <text x={(s.x1+s.x2)/2+6} y={s.ym-4} fontSize="10" fill="#e07b00" fontWeight="700">ȳ/2</text>
            <text x={(s.x1+s.x2)/2} y={ioy+26} textAnchor="middle" fontSize="10" fill="#27ae60" fontWeight="700">dx</text>
          </>;
        })()}

        {/* composite centroid */}
        {(()=>{
          // ∫x·y dx / ∫y dx  for y=x² from 0 to 2
          // ∫x·x² dx = ∫x³ dx = [x⁴/4]₀²= 4
          // ∫x² dx = [x³/3]₀² = 8/3
          // x̄ = 4/(8/3) = 3/2 = 1.5
          // ȳ: ∫(1/2)y² dx = ∫(1/2)x⁴ dx = [x⁵/10]₀² = 32/10 = 3.2
          // ȳ = 3.2/(8/3) = 3.2*3/8 = 1.2
          const gx = tx(1.5), gy = ty(1.2);
          return <>
            <circle cx={gx} cy={gy} r={8} fill="#e07b00" stroke="#fff" strokeWidth="2"/>
            <text x={gx+11} y={gy-6} fontSize="13" fill="#e07b00" fontWeight="700">G</text>
            <line x1={iox} y1={gy} x2={gx} y2={gy} stroke="#e07b00" strokeWidth="1" strokeDasharray="3,2"/>
            <line x1={gx} y1={ioy} x2={gx} y2={gy} stroke="#e07b00" strokeWidth="1" strokeDasharray="3,2"/>
            <text x={(iox+gx)/2} y={gy-5} fontSize="11" fill="#e07b00" fontWeight="700">x̄=1.5</text>
            <text x={gx+4} y={(ioy+gy)/2+4} fontSize="11" fill="#e07b00" fontWeight="700">ȳ=1.2</text>
          </>;
        })()}

        <rect x={18} y={268} width={lw-26} height={46} rx={3} fill="#EBF3FB" stroke="#2E75B6" strokeWidth="1"/>
        <text x={24} y={283} fontSize="12" fill="#1F3864" fontWeight="700">x̄ = (1/A)∫x dA = (1/A)∫x·y dx</text>
        <text x={24} y={299} fontSize="12" fill="#1F3864" fontWeight="700">ȳ = (1/A)∫ȳ_el dA = (1/A)∫(y/2)·y dx</text>
        <text x={24} y={308} fontSize="11" fill="#555">Here A = ∫y dx,  dA = y dx  (vertical strip)</text>

        {/* Right: Pappus theorem + horizontal strips */}
        <rect x={rpx} y={10} width={W-rpx-10} height={H-20} rx={5} fill="#fff" stroke="#ccd9ea"/>
        <text x={rpx+(W-rpx-10)/2} y={28} textAnchor="middle" fontSize="15" fill="#1F3864" fontWeight="700">Pappus's Theorem</text>

        {[
          {y:44,  bg:'#EBF3FB', bc:'#2E75B6',  title:'Surface of Revolution',
           lines:["S = 2π ȳ · L","ȳ = centroid distance from axis","L = arc length of the curve"]},
          {y:134, bg:'#f0fff4', bc:'#27ae60',   title:'Volume of Revolution',
           lines:["V = 2π ȳ · A","ȳ = centroid distance from axis","A = area of the plane figure"]},
          {y:224, bg:'#fff7ee', bc:'#e07b00',   title:'Example — Torus',
           lines:["Circle radius r, centre at distance R","V = 2π R · (πr²) = 2π²Rr²","S = 2π R · (2πr) = 4π²Rr"]},
        ].map(({y,bg,bc,title,lines})=>(
          <g key={title}>
            <rect x={rpx+8} y={y} width={W-rpx-26} height={82} rx={4} fill={bg} stroke={bc} strokeWidth="1.2"/>
            <text x={rpx+14} y={y+16} fontSize="13" fill="#1F3864" fontWeight="700">{title}</text>
            {lines.map((ln,i)=>(
              <text key={i} x={rpx+14} y={y+34+i*17} fontSize="11" fill={i===0?bc:'#555'} fontFamily={i===0?"'Courier New',monospace":"'Georgia',serif"} fontWeight={i===0?'700':'400'}>{ln}</text>
            ))}
          </g>
        ))}
      </svg>
      <div style={S.dCaption}>The centroid by integration uses vertical (or horizontal) strips as area elements dA=y dx. The x̄ coordinate is the first moment of area divided by total area. Pappus's theorem shortcuts revolution problems: the volume/surface of revolution equals the area/perimeter times the distance travelled by the centroid.</div>
    </div>
  );
}

// ── Diagram 5: Second Moment of Area ─────────────────────────────
function DiagramSecondMoment() {
  const W = 900, H = 330;

  // Left: I_x and I_y for a rectangle
  const lw = 430;
  const rx0 = 70, ry0 = 240;
  const rw = 230, rh = 130;
  const rcx = rx0+rw/2, rcy = ry0-rh/2;

  // Right: parallel axis theorem
  const rpx = 460;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Second Moment of Area — I_x, I_y, and the Parallel Axis Theorem</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>

        {/* Left: rectangle second moment */}
        <rect x={10} y={10} width={lw} height={H-20} rx={5} fill="#fff" stroke="#ccd9ea"/>
        <text x={10+lw/2} y={28} textAnchor="middle" fontSize="15" fill="#1F3864" fontWeight="700">Second Moment of Area — Rectangle</text>

        {/* rectangle */}
        <rect x={rx0} y={ry0-rh} width={rw} height={rh} fill="#d0e8ff" fillOpacity="0.4" stroke="#2E75B6" strokeWidth="2"/>

        {/* centroidal axes */}
        <line x1={rx0-20} y1={rcy} x2={rx0+rw+20} y2={rcy} stroke="#e07b00" strokeWidth="1.8" strokeDasharray="6,3"/>
        <line x1={rcx} y1={ry0-rh-20} x2={rcx} y2={ry0+20} stroke="#27ae60" strokeWidth="1.8" strokeDasharray="6,3"/>
        <text x={rx0+rw+24} y={rcy+4} fontSize="12" fill="#e07b00" fontWeight="700">x̄</text>
        <text x={rcx+4} y={ry0-rh-22} fontSize="12" fill="#27ae60" fontWeight="700">ȳ</text>

        {/* G */}
        <circle cx={rcx} cy={rcy} r={6} fill="#e07b00" stroke="#fff" strokeWidth="2"/>
        <text x={rcx+9} y={rcy-6} fontSize="12" fill="#e07b00" fontWeight="700">G</text>

        {/* base axis */}
        <line x1={rx0-20} y1={ry0} x2={rx0+rw+20} y2={ry0} stroke="#c0392b" strokeWidth="1.6"/>
        <text x={rx0+rw+24} y={ry0+4} fontSize="12" fill="#c0392b" fontWeight="700">x</text>

        {/* dimension labels */}
        <line x1={rx0} y1={ry0+14} x2={rx0+rw} y2={ry0+14} stroke="#2E75B6" strokeWidth="1.2"/>
        <text x={rcx} y={ry0+26} textAnchor="middle" fontSize="13" fill="#2E75B6" fontWeight="700">b</text>
        <line x1={rx0-14} y1={ry0} x2={rx0-14} y2={ry0-rh} stroke="#2E75B6" strokeWidth="1.2"/>
        <text x={rx0-26} y={rcy+4} textAnchor="middle" fontSize="13" fill="#2E75B6" fontWeight="700">h</text>

        {/* distance d */}
        <line x1={rx0+rw+40} y1={rcy} x2={rx0+rw+40} y2={ry0} stroke="#555" strokeWidth="1.2"/>
        <line x1={rx0+rw+35} y1={rcy} x2={rx0+rw+45} y2={rcy} stroke="#555" strokeWidth="1.2"/>
        <line x1={rx0+rw+35} y1={ry0} x2={rx0+rw+45} y2={ry0} stroke="#555" strokeWidth="1.2"/>
        <text x={rx0+rw+52} y={(rcy+ry0)/2+4} fontSize="13" fill="#555" fontWeight="700">d=h/2</text>

        <rect x={18} y={258} width={lw-26} height={56} rx={3} fill="#EBF3FB" stroke="#2E75B6" strokeWidth="1"/>
        <text x={24} y={273} fontSize="12" fill="#1F3864" fontWeight="700">Centroidal axes:</text>
        <text x={24} y={289} fontSize="12" fill="#e07b00" fontFamily="'Courier New',monospace">Īₓ = bh³/12  (about centroidal x-axis)</text>
        <text x={24} y={305} fontSize="12" fill="#27ae60" fontFamily="'Courier New',monospace">Īᵧ = hb³/12  (about centroidal y-axis)</text>

        {/* Right: parallel axis theorem */}
        <rect x={rpx} y={10} width={W-rpx-10} height={H-20} rx={5} fill="#fff" stroke="#ccd9ea"/>
        <text x={rpx+(W-rpx-10)/2} y={28} textAnchor="middle" fontSize="15" fill="#1F3864" fontWeight="700">Parallel Axis Theorem</text>

        {/* small rect shifted */}
        {(()=>{
          const srx=rpx+50, sry=220, srw=150, srh=80;
          const srcx=srx+srw/2, srcy=sry-srh/2;
          const d=srh/2; // distance from centroid to base
          return <>
            <rect x={srx} y={sry-srh} width={srw} height={srh} fill="#d0f0d8" fillOpacity="0.4" stroke="#27ae60" strokeWidth="2"/>
            {/* centroidal axis */}
            <line x1={srx-15} y1={srcy} x2={srx+srw+15} y2={srcy} stroke="#e07b00" strokeWidth="1.8" strokeDasharray="5,3"/>
            <text x={srx+srw+18} y={srcy+4} fontSize="11" fill="#e07b00" fontWeight="700">G (Ī)</text>
            {/* reference axis */}
            <line x1={srx-15} y1={sry} x2={srx+srw+15} y2={sry} stroke="#c0392b" strokeWidth="1.8"/>
            <text x={srx+srw+18} y={sry+4} fontSize="11" fill="#c0392b" fontWeight="700">x (I)</text>
            {/* distance d */}
            <line x1={srx+srw+38} y1={srcy} x2={srx+srw+38} y2={sry} stroke="#9b59b6" strokeWidth="1.4"/>
            <line x1={srx+srw+33} y1={srcy} x2={srx+srw+43} y2={srcy} stroke="#9b59b6" strokeWidth="1.2"/>
            <line x1={srx+srw+33} y1={sry} x2={srx+srw+43} y2={sry} stroke="#9b59b6" strokeWidth="1.2"/>
            <text x={srx+srw+50} y={(srcy+sry)/2+4} fontSize="13" fill="#9b59b6" fontWeight="700">d</text>
            <circle cx={srcx} cy={srcy} r={5} fill="#e07b00" stroke="#fff" strokeWidth="1.5"/>
          </>;
        })()}

        <rect x={rpx+8} y={40} width={W-rpx-26} height={100} rx={4} fill="#EBF3FB" stroke="#2E75B6" strokeWidth="1.2"/>
        <text x={rpx+14} y={58} fontSize="13" fill="#1F3864" fontWeight="700">Parallel Axis Theorem:</text>
        <text x={rpx+14} y={76} fontSize="14" fill="#2E75B6" fontFamily="'Courier New',monospace" fontWeight="700">I = Ī + Ad²</text>
        <text x={rpx+14} y={94} fontSize="11" fill="#555">Ī = second moment about centroidal axis</text>
        <text x={rpx+14} y={110} fontSize="11" fill="#555">A = cross-sectional area</text>
        <text x={rpx+14} y={126} fontSize="11" fill="#555">d = distance between parallel axes</text>

        <rect x={rpx+8} y={248} width={W-rpx-26} height={56} rx={3} fill="#fff7ee" stroke="#e07b00" strokeWidth="1"/>
        <text x={rpx+14} y={264} fontSize="12" fill="#1F3864" fontWeight="700">Rectangle about base (x-axis):</text>
        <text x={rpx+14} y={281} fontSize="12" fill="#e07b00" fontFamily="'Courier New',monospace">Iₓ = Ī + Ad² = bh³/12 + bh(h/2)²</text>
        <text x={rpx+14} y={297} fontSize="12" fill="#e07b00" fontFamily="'Courier New',monospace">   = bh³/12 + bh³/4 = bh³/3</text>
      </svg>
      <div style={S.dCaption}>The second moment of area (area moment of inertia) I measures resistance to bending. It is smallest about the centroidal axis — the parallel axis theorem I=Ī+Ad² shifts it to any parallel axis at distance d. Engineers use I to calculate beam deflections and stresses.</div>
    </div>
  );
}

// ── Diagram 6: Centroid Table ─────────────────────────────────────
function DiagramTable() {
  const W = 900, H = 370;

  const rows = [
    { shape:'Rectangle',        area:'bh',         xbar:'b/2',         ybar:'h/2',          Ix:'bh³/12',   Iy:'hb³/12',   color:'#2E75B6',  fill:'#EBF3FB' },
    { shape:'Right Triangle',   area:'bh/2',        xbar:'b/3',         ybar:'h/3',          Ix:'bh³/36',   Iy:'hb³/36',   color:'#27ae60',  fill:'#f0fff4' },
    { shape:'Circle',           area:'πr²',         xbar:'r',           ybar:'r',            Ix:'πr⁴/4',    Iy:'πr⁴/4',    color:'#c0392b',  fill:'#fde8e8' },
    { shape:'Semicircle',       area:'πr²/2',       xbar:'r',           ybar:'4r/3π',        Ix:'πr⁴/8',    Iy:'πr⁴/8',    color:'#9b59b6',  fill:'#f5d0ff' },
    { shape:'Quarter Circle',   area:'πr²/4',       xbar:'4r/3π',       ybar:'4r/3π',        Ix:'πr⁴/16',   Iy:'πr⁴/16',   color:'#e07b00',  fill:'#fff7ee' },
    { shape:'Triangle (gen.)',  area:'bh/2',        xbar:'(x₁+x₂+x₃)/3', ybar:'(y₁+y₂+y₃)/3',Ix:'bh³/36',  Iy:'—',        color:'#1F3864',  fill:'#f0f4f8' },
  ];

  const rowH = 44;
  const cols = [200, 100, 110, 110, 120, 120];
  const colX = [14];
  cols.forEach((w,i) => colX.push(colX[i]+w));
  const headers = ['Shape','Area A','x̄ (from ref)','ȳ (from ref)','Ī_x (centroidal)','Ī_y (centroidal)'];

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Centroid and Second Moment Reference Table</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        {/* Header */}
        <rect x={10} y={10} width={W-20} height={36} rx={4} fill="#1F3864"/>
        {headers.map((h,i)=>(
          <text key={i} x={colX[i]+cols[i]/2+4} y={33} textAnchor="middle" fontSize="12" fill="#fff" fontWeight="700">{h}</text>
        ))}

        {/* Data rows */}
        {rows.map((r,ri)=>{
          const y = 46 + ri*rowH;
          const vals = [r.shape, r.area, r.xbar, r.ybar, r.Ix, r.Iy];
          return (
            <g key={r.shape}>
              <rect x={10} y={y} width={W-20} height={rowH} rx={0} fill={r.fill}/>
              {/* colour strip */}
              <rect x={10} y={y} width={8} height={rowH} fill={r.color}/>
              {/* cell borders */}
              {colX.slice(1,-1).map((cx,i)=>(
                <line key={i} x1={cx+4} y1={y} x2={cx+4} y2={y+rowH} stroke="#ccd9ea" strokeWidth="0.8"/>
              ))}
              <line x1={10} y1={y+rowH} x2={W-10} y2={y+rowH} stroke="#ccd9ea" strokeWidth="0.8"/>
              {vals.map((v,i)=>(
                <text key={i} x={colX[i]+cols[i]/2+4} y={y+rowH/2+5} textAnchor="middle"
                  fontSize={i===0?12:11} fill={i===0?r.color:'#333'}
                  fontWeight={i===0?'700':'400'}
                  fontFamily={i>0?"'Courier New',monospace":"'Georgia',serif"}>
                  {v}
                </text>
              ))}
            </g>
          );
        })}

        {/* Note row */}
        <rect x={10} y={46+rows.length*rowH} width={W-20} height={36} rx={0} fill="#f8fbff"/>
        <line x1={10} y1={46+rows.length*rowH+36} x2={W-10} y2={46+rows.length*rowH+36} stroke="#ccd9ea" strokeWidth="0.8"/>
        <text x={18} y={46+rows.length*rowH+22} fontSize="11" fill="#555">
          Note: x̄ and ȳ measured from a corner/base. Ī values are about the centroidal axis through G. Use I = Ī + Ad² to shift to any parallel axis.
        </text>

        {/* bottom border */}
        <rect x={10} y={10} width={W-20} height={H-20} rx={4} fill="none" stroke="#ccd9ea" strokeWidth="1.5"/>
      </svg>
      <div style={S.dCaption}>Quick-reference table for the six most common 2D sections. The reference origin is at the bottom-left corner for rectangles and triangles, and at the centre of the diameter for circular sections. For the circle, x̄=ȳ=r means the centroid is at the geometric centre.</div>
    </div>
  );
}

// ── Main ─────────────────────────────────────────────────────────
export default function Centroids() {
  return (
    <div style={S.wrapper}>
      <h1 style={S.h1}>Centroids</h1>
      <p style={S.p}>The centroid of a body is its geometric centre — the point at which the entire area (or mass) may be considered to act. For uniform bodies it coincides with the centre of mass and the balance point. Centroids are fundamental to structural engineering, where they determine neutral axes and bending stiffness, and to mechanics, where they locate where resultant forces act.</p>

      <InfoBox title="Core Idea: The centroid is the area-weighted average position" items={[
        "Discrete masses: x̄ = Σmᵢxᵢ / Σmᵢ  —  mass-weighted mean of x-coordinates",
        "Plane area: x̄ = (1/A)∫x dA  —  first moment of area divided by total area",
        "Triangle: G = average of the three vertices — always at (x₁+x₂+x₃)/3",
        "Composite: x̄ = Σ(Aᵢx̄ᵢ) / ΣAᵢ  —  holes enter with negative area",
        "Parallel axis theorem: I = Ī + Ad²  —  shift second moment to any parallel axis",
        "Pappus's theorem: V = 2π ȳ A  —  volume = centroid distance × 2π × area",
      ]}/>

      <h2 style={S.h2}>The Centroid Concept</h2>
      <DiagramCentroidConcept/>
      <Table2 rows={[
        ["Discrete point masses","x̄ = Σmᵢxᵢ / Σmᵢ,  ȳ = Σmᵢyᵢ / Σmᵢ\nFor uniform masses mᵢ=1: reduces to simple average of coordinates"],
        ["Plane area (continuous)","x̄ = (1/A)∬x dA,  ȳ = (1/A)∬y dA\nIntegrate over the region; A = total area"],
        ["Triangle centroid","G = ((x₁+x₂+x₃)/3, (y₁+y₂+y₃)/3)\nAlways at 1/3 of the way from each side, 2/3 from each vertex"],
        ["Median property","Each median is divided 2:1 by G (longer part at vertex)\nG lies on every median"],
        ["Uniform lamina","Centroid = centre of mass for uniform density\nBalances on any axis through G"],
        ["Centroidal axis","Any axis through G is a centroidal axis\nFirst moment of area about a centroidal axis = 0"],
      ]}/>

      <h2 style={S.h2}>Centroids of Standard Shapes</h2>
      <DiagramStandardShapes/>
      <Table2 rows={[
        ["Rectangle (b × h)","x̄ = b/2,  ȳ = h/2  (from bottom-left corner)\nCentroid at the geometric centre"],
        ["Triangle (base b, height h)","x̄ = b/3,  ȳ = h/3  (from right-angle corner for right triangle)\nGenerally: average of vertex coordinates"],
        ["Circle (radius r)","x̄ = r,  ȳ = r  (i.e. at the centre)\nȳ = 0 if origin at centre"],
        ["Semicircle (radius r)","x̄ = r (on diameter),  ȳ = 4r/(3π) ≈ 0.424r\nMeasured from centre of diameter"],
        ["Quarter circle (radius r)","x̄ = ȳ = 4r/(3π) ≈ 0.424r\nMeasured from the corner (centre of full circle)"],
        ["Ellipse (semi-axes a, b)","x̄ = a,  ȳ = b  (measured from centre)\nCentroid at geometric centre; area = πab"],
      ]}/>

      <h2 style={S.h2}>Composite Bodies</h2>
      <DiagramComposite/>
      <Table2 rows={[
        ["Composite formula","x̄ = Σ(Aᵢx̄ᵢ) / ΣAᵢ,  ȳ = Σ(Aᵢȳᵢ) / ΣAᵢ\nWork from a common reference origin for all parts"],
        ["Subtracting holes","Treat hole as a part with negative area −Ahole\nx̄ = (A₁x̄₁ − A₂x̄₂) / (A₁ − A₂)"],
        ["Reference origin","Choose a convenient fixed point — usually a corner\nAll x̄ᵢ, ȳᵢ measured from the same origin"],
        ["Multiple parts","Works for any number of simple shapes combined\nBreak complex shapes into rectangles, triangles, circles"],
        ["Symmetry shortcut","If shape has a line of symmetry, centroid lies on that line\nTwo axes of symmetry → centroid at their intersection"],
        ["Thin-walled sections","Treat each wall as a line with 'area' = thickness × length\nSame formula applies: x̄ = Σ(Lᵢx̄ᵢ) / ΣLᵢ"],
      ]}/>

      <h2 style={S.h2}>Centroid by Integration</h2>
      <DiagramIntegration/>
      <Table2 rows={[
        ["Vertical strip method","dA = y dx,  x̄_el = x,  ȳ_el = y/2\nx̄ = (1/A)∫x·y dx;  ȳ = (1/A)∫(y²/2) dx"],
        ["Horizontal strip method","dA = x dy,  x̄_el = x/2,  ȳ_el = y\nx̄ = (1/A)∫(x²/2) dy;  ȳ = (1/A)∫y·x dy"],
        ["Between two curves","dA = (y_top − y_bot) dx\nx̄ = (1/A)∫x(y_top−y_bot) dx"],
        ["Pappus's theorem (volume)","V = 2π ȳ A\nVolume of solid of revolution = 2π × (centroid dist.) × area"],
        ["Pappus's theorem (surface)","S = 2π ȳ L\nSurface area = 2π × (centroid dist.) × arc length"],
        ["Torus example","Circle radius r centred at distance R from axis\nV = 2π²Rr²,  S = 4π²Rr — both from Pappus"],
      ]}/>

      <h2 style={S.h2}>Second Moment of Area</h2>
      <DiagramSecondMoment/>
      <Table2 rows={[
        ["Definition","Iₓ = ∫y² dA,  Iᵧ = ∫x² dA\nMeasures resistance to bending about that axis; units: length⁴"],
        ["Polar second moment","J = Iₓ + Iᵧ = ∫r² dA\nUsed for torsion; J = πr⁴/2 for a solid circle"],
        ["Rectangle (centroidal)","Īₓ = bh³/12  (about centroidal horizontal axis)\nĪᵧ = hb³/12  (about centroidal vertical axis)"],
        ["Rectangle (base)","Iₓ = bh³/3  (about the base)\nDerived from Parallel Axis Theorem: Ī + Ad²"],
        ["Parallel Axis Theorem","I = Ī + Ad²\nĪ = centroidal value; A = area; d = distance between axes"],
        ["Circle (centroidal)","Iₓ = Iᵧ = πr⁴/4;  J = πr⁴/2\nHollow circle: I = π(R⁴−r⁴)/4"],
        ["Radius of gyration","k = √(I/A)  so that I = Ak²\nUseful for comparing sections of different sizes"],
        ["Section modulus","Z = I/y_max\nUsed in beam bending stress formula: σ = M/Z"],
      ]}/>

      <h2 style={S.h2}>Quick Reference Table</h2>
      <DiagramTable/>

      <InfoBox title="Key Takeaway — Centroid Problem Strategy" items={[
        "Simple shape? → Look up x̄, ȳ from the standard table",
        "Triangle from coordinates? → G = average of the three vertices",
        "Composite shape? → Split into simple parts, use x̄ = Σ(Aᵢx̄ᵢ)/ΣAᵢ",
        "Has a hole? → Subtract: treat hole as part with −A",
        "Shape has symmetry? → Centroid lies on every axis of symmetry",
        "Need I about a non-centroidal axis? → Use I = Ī + Ad²",
        "Volume of revolution? → V = 2π ȳ A  (Pappus's theorem)",
        "Integration needed? → Choose strips parallel to one axis; use dA = f(x) dx",
      ]}/>
    </div>
  );
}